export default "__VITE_ASSET__DJU3BPEm__"